<template>
  <w-modal
    v-model="show"
    title="Raport KO"
    class="modal-big"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @close="close"
  >
    <ko-report v-if="step === 1" :schema="$schema" />

    <div v-if="step === 2" class="ko-report-preview">
      <iframe ref="iframe" :srcdoc="preview" :style="{ height: iframeHeight }" />
    </div>

    <template slot="footer">
      <div class="w-100 d-flex justify-content-between">
        <w-button text="Anuluj" class="btn-danger" @click="close" />

        <div class="d-flex">
          <w-button text="Wróć" class="btn-secondary mr-5" :disabled="step === 1" @click="step = 1" />

          <w-button v-if="step === 2" text="Wyślij Raport KO do MDOK" class="btn-primary" @click="nextStep" />

          <w-button v-else text="Podgląd" class="btn-primary" @click="nextStep" />
        </div>
      </div>
    </template>
  </w-modal>
</template>

<script>
import { schemaMixin } from '@witkac/jschema';
import moment from 'moment';

import KoReport from '@/components/forms/actionData/KoReport.vue';
import { Errors } from '@/enums/errors.enum';
import { Successes } from '@/enums/successes.enum';
import { iframeMixin } from '@/mixins/iframe';
import { modalMixin } from '@/mixins/modal';
import { notificationsMixin } from '@/mixins/notifications';
import { koResource } from '@/resources/ko.resource';
import schema from '@/schemas/koReport.schema';
import { serverError } from '@/utils/serverError';

// @vuese
// Modal dodania
// @group
export default {
  components: { KoReport },
  mixins: [iframeMixin(), notificationsMixin, modalMixin, schemaMixin],
  schema,

  data() {
    return { model: {}, preview: '', step: 1 };
  },

  computed: {
    procedureId() {
      return parseInt(this.$route.params.procedureId);
    }
  },

  methods: {
    nextStep() {
      if (this.$schema.$validateAll().length) {
        this.notifyError(Errors.FORM_CORRECT_ERRORS);
        return;
      }
      if (this.step === 1) {
        return this.openPreview();
      }

      return this.submit();
    },

    openPreview() {
      const data = this.$schema.$getData();
      koResource
        .previewKoReport({ procedureId: this.procedureId, data, date: this.getDate(data) })
        .then(preview => {
          this.preview = preview;
          this.step = 2;
        })
        .catch(err => this.notifyError(serverError(err)));
    },

    submit() {
      const data = this.$schema.$getData();
      koResource
        .sendKoReportToMdok({ procedureId: this.procedureId, data, date: this.getDate(data) })
        .then(() => {
          this.notifySuccess(Successes.KO_REPORT_SENT);
          this.close();
        })
        .catch(err => this.notifyError(serverError(err)));
    },

    getDate(data) {
      return moment(`${data.year}-${(data.month + 1).toString().padStart(2, '0')}-01`)
        .endOf('month')
        .toDate();
    }
  }
};
</script>

<style>
.ko-report-preview {
  border: 1px solid black;
}

.ko-report-preview iframe {
  width: 99%;
  border: none;
}
</style>
